import { useState } from 'react'

import { NotificationContext } from './context'
import { NotificationConfig } from '~/types/notifications'

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState<NotificationConfig | null>(null)

  return (
    <NotificationContext.Provider value={{ notification, setNotification }}>
      {children}
    </NotificationContext.Provider>
  )
}